module.exports = __webpack_public_path__ + "static/img/SF116_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/SF116_1.png
// module id = h2ZR
// module chunks = 0